export default __webpack_public_path__ + "static/media/video-sample.fabdb15b.mp4";